import type { CSSProperties } from 'react';
import {
	formatPrice,
	isPriceInformed,
	priceUnitLabel,
	productKey,
	toPriceUnitValue,
	type PackProduct,
	type ProductPriceMap,
} from '../../utils/productCosts';
import styles from './ProductCostsModal.module.css';

interface ProductCostsViewProps {
	products: PackProduct[];
	prices: ProductPriceMap;
	columns: number;
}

export const ProductCostsView = ({ products, prices, columns }: ProductCostsViewProps) => (
	<div className={styles.viewGrid} style={{ '--cost-columns': columns } as CSSProperties}>
		{products.map((product) => {
			const price = prices[productKey(product.id)];
			return (
				<div key={product.id} className={styles.viewItem}>
					<span className={styles.name} title={product.name}>
						{product.name}
					</span>
					{isPriceInformed(price) ? (
						<span className={styles.value}>
							{formatPrice(price.price)}
							<span className={styles.unit}> /{priceUnitLabel(toPriceUnitValue(price))}</span>
						</span>
					) : (
						<span className={styles.unit}>Não informado</span>
					)}
				</div>
			);
		})}
	</div>
);
